export default __webpack_public_path__ + "static/media/creative-nobg.1ff02e8d.gif";